import {API_ROOT_URL} from 'envs/_current/config'
import {schema} from 'normalizr'
import {baseFieldTypes} from './base/baseFieldTypes'
import {chartSchema} from './chart'
import {
    articleSchema,
    askSchema,
    channelSchema,
    organizationDepartmentSchema,
    organizationSchema,
    pollSchema,
    postSchema,
} from './schema'
import {commentSchema} from './schema/commentSchema'
import {eventSchema} from './schema/event'
import {createTransform} from './utils/createTransform'
import {godwordsSchema} from "./godwords";
import {createListTransform} from "./utils/createListTransform";

export const voteSchema = new schema.Union(
    {
        post: postSchema,
        ask: askSchema,
        poll: pollSchema,
        comment: commentSchema,
        article: articleSchema,
        chart: chartSchema,
        event: eventSchema,
        channel: channelSchema,
        organization: organizationSchema,
        organization_department: organizationDepartmentSchema,
        god_word: godwordsSchema,
    },
    '_type'
)

const fields = ['owner_type', 'owner_id']

const fieldTypes = {
    owner_id: baseFieldTypes.string,
    owner_type: 'post',
}

// Route::post('auth/vote/up', 'VoteController@add');
export const vote_add_Api = {
    backend: `Route::post('auth/vote/up', 'VoteController@add');`,
    root: API_ROOT_URL,
    path: '/auth/vote/up',
    method: 'POST',
    fields,
    fieldTypes,
    schema: voteSchema.define,
    transform: createTransform(voteSchema, 'data'),
}

// Route::post('auth/vote/down', 'VoteController@remove');
export const vote_remove_Api = {
    backend: `// Route::post('auth/vote/down', 'VoteController@remove');`,
    root: API_ROOT_URL,
    path: '/auth/vote/down',
    method: 'POST',
    fields,
    fieldTypes,
    schema: voteSchema.define,
    transform: createTransform(voteSchema, 'data'),
}

export const vote_voteUp_Api = {
    backend: `Route::post('auth/vote/count-up', 'VoteController@voteUp');`,
    root: API_ROOT_URL,
    path: '/auth/vote/count-up',
    method: 'POST',
    schema: postSchema,
    fields,
    fieldTypes,
    transform: createTransform(voteSchema, 'data'),
}

export const vote_voteDown_Api = {
    backend: `Route::post('auth/vote/count-down', 'VoteController@voteDown');`,
    root: API_ROOT_URL,
    path: '/auth/vote/count-down',
    method: 'POST',
    schema: postSchema,
    fields,
    fieldTypes,
    transform: createTransform(voteSchema, 'data'),
}

export const vote_getVotedItems_Api = {
    backend: `Route::get('auth/vote/{type}/gets', 'VoteController@getVotedItems');`,
    root: API_ROOT_URL,
    path: '/auth/vote/:type/gets',
    method: 'GET',
    schema: voteSchema,
    fields,
    fieldTypes,
    transform: createListTransform(voteSchema),
}
